
import Pet from "../../../assets/outline/Pet.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PetIcon({ className, dataTestid = "PetIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Pet data-testid={dataTestid} className={classes} {...rest} />
  );
}
